import script from "./CardHeadingSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHeadingSimple.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__